<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <ellipse cx="140" cy="50" rx="37" ry="37" />
      <ellipse cx="40" cy="50" rx="37" ry="37" />
      <ellipse cx="90" cy="120" rx="59.5" ry="59.5" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ratoncito"
}
</script>
